import React, { Fragment, useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { NotificationManager } from 'react-notifications';
import TextInput from './TextInput';
import ReactRTE from './ReactRTE';
import DropDown from './DropDown';
import { domains } from '../configs/domains';
import * as PageService from '../Services/PageService';
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import { Auth } from 'aws-amplify';

const ALLOW_SLUG_EDIT = ['dewstarsforever@gmail.com', 'ahmed.abouhegaza@gmail.com'];
export default function EditPage({ type, existingValues }) {
	const navigate = useNavigate();
	const [enable, setEnable] = useState(true);
	const [user, setUser] = useState(null);

	useEffect(() => {
		Auth.currentAuthenticatedUser().then((res) => {
			setUser(res.attributes.email);
		});
	}, []);
	let initialValues =
		type == 'CREATE'
			? createInitialValues
			: existingValues;
	const formik = useFormik({
		initialValues,
		validationSchema,
		onSubmit: (values) => {
			console.log('submitting');
			if (type == 'CREATE') {
				PageService.createPage(values)
					.then((response) => {
						console.log('----->', response);
						NotificationManager.success(`Page Created`);
						navigate(`/update-page/${encodeURIComponent(response.domain)}/${encodeURIComponent(response.url)}`);
					})
					.catch((e) => {
						console.log(e);
						NotificationManager.error(`Error Creating Page`);
						setEnable(true);
					});
			} else {
				PageService.updatePage({
					...existingValues,
					...values
				}).then((response) => {
						console.log(response);
						NotificationManager.success(`Updated`);
						setEnable(true);
				}).catch((e) => {
						console.log(e);
						NotificationManager.error(`Error Updating`);
						setEnable(true);
				});
			}
		}
	});

	return (
		<Fragment>

			<form>
				<DropDown
					onChange={(data) => {
						console.log(data);
						formik.setFieldValue('domain', data.value);
					}}
					value={formik.values.domain}
					name="domain"
					options={domains}
					label="Select domain"
					error={formik.errors.domain}
					disabled={type != 'CREATE'}
				/>
				<TextInput
					label="Url"
					placeholder="Url"
					name="url"
					onChange={formik.handleChange}
					value={formik.values.url}
					disabled={!enable || (type === 'UPDATE' && !ALLOW_SLUG_EDIT.includes(user))}
					error={formik.errors.url}
					message={type != 'CREATE' ? 'You need a manager approval to change Url' : null}
				/>
				<TextInput
					label="Title"
					placeholder="Title"
					name="title"
					onChange={formik.handleChange}
					value={formik.values.title}
					disabled={!enable}
					error={formik.errors.title}
				/>
				<TextInput
					label="SEO Title"
					placeholder="SEO Title (Max 60 characters)"
					name="seoTitle"
					onChange={formik.handleChange}
					value={formik.values.seoTitle}
					disabled={!enable}
					error={formik.errors.seoTitle}
				/>
				<TextInput
					label="SEO Description (Max 160 characters)"
					placeholder="SEO Description (Max 160 characters)"
					name="seoDescription"
					onChange={formik.handleChange}
					value={formik.values.seoDescription}
					disabled={!enable}
					error={formik.errors.seoDescription}
				/>
				<label className="w-full form-label font-bold inline-block mt-2 text-gray-700">Body</label>
				<ReactRTE value={formik.values.body} setValue={formik.setFieldValue} name="body" id="body" />
				<Button text="Submit" disabled={!enable} type="submit" onClick={formik.handleSubmit} />
			</form>


		</Fragment>
	);
}

const validationSchema = Yup.object().shape({
	domain: Yup.string().required('Required'),
	url: Yup.string()
		.min(1, 'Too Short! It should be more than 3')
		.max(61, 'Too Long! It should be less than 160')
		.matches(/^[a-z0-9_./-]+$/, 'Lower case characters, numbers and dashes only. So white spaces!')
		.required('Required')
		.test("It must start with /", "It must start with /", function () {
            let url = this.parent["url"];
             console.log("url ",url);
			return url.indexOf('/')==0
        }),
	title: Yup.string()
		.min(3, 'Too Short! It should be more than 3')
		.max(61, 'Too Long! It should be less than 60')
		.required('Required'),
	seoTitle: Yup.string()
		.min(3, 'Too Short! It should be more than 3')
		.max(61, 'Too Long! It should be less than 60')
		.required('Required'),
	seoDescription: Yup.string()
		.min(3, 'Too Short! It should be more than 3')
		.max(160, 'Too Long! It should be less than 160')
		.required('Required'),
	body: Yup.string().min(3, 'Too Short! It should be more than 3').required('Required'),

});

const createInitialValues = {
	title: '',
	seoTitle: '',
	seoDescription: '',
	url: '',
	domain: '',
	body: ''
};

